import { Link } from 'react-router-dom';

import { Box, Button, Fab, useMediaQuery, useTheme } from '@mui/material';

export interface ToolbarButtonProps {
  url: string;
  label: string;
  icon: JSX.Element;
}

export default function ToolbarButton(props: ToolbarButtonProps) {
  const { url, label, icon } = props;

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('md'));

  if (matches) {
    return (
      <Fab
        size="small"
        color="primary"
        aria-label={label}
        component={Link}
        to={url}
        sx={{ boxShadow: 'none' }}
      >
        {icon}
      </Fab>
    );
  }

  return (
    <Button
      variant="contained"
      color="primary"
      disableElevation
      component={Link}
      to={url}
    >
      {icon}
      <Box ml={1}>{label}</Box>
    </Button>
  );
}
